"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('skeleton');
const Skeleton = (props) => {
    const { title = true, titleColor, backgroundColor, active, avatar = false, loading = true, image = false, paragraph = { rows: 3, width: [80, 'auto', 200] }, repetitions = 1, space, customize, fade, style, children, } = props;
    const [loadingEnd, setLoadingEnd] = react_1.default.useState(false);
    const [renderStart, setRenderStart] = react_1.default.useState(false);
    react_1.useEffect(() => {
        if (fade) {
            if (!loading) {
                setTimeout(() => {
                    setLoadingEnd(true);
                }, 300);
            }
            if (loading) {
                setLoadingEnd(false);
                setRenderStart(false);
            }
        }
    }, [loading]);
    react_1.useEffect(() => {
        if (fade) {
            if (loadingEnd) {
                setTimeout(() => {
                    setRenderStart(true);
                }, 100);
            }
        }
    }, [loadingEnd]);
    const rows = react_1.useMemo(() => (paragraph.rows ? [...new Array(paragraph.rows).keys()] : []), [
        paragraph,
    ]);
    const rowsWidth = react_1.useMemo(() => {
        var _a;
        if (typeof paragraph.width === 'number') {
            return [...new Array(rows.length).fill(`${paragraph.width}px`)];
        }
        if (typeof paragraph.width === 'string') {
            return [...new Array(rows.length).fill(paragraph.width)];
        }
        if (Array.isArray(paragraph.width)) {
            return (_a = paragraph.width) === null || _a === void 0 ? void 0 : _a.map((i) => {
                if (typeof i === 'number') {
                    return `${i}px`;
                }
                else if (typeof i === 'string') {
                    return i;
                }
                else {
                    return 'auto';
                }
            });
        }
    }, [paragraph]);
    const renderImage = (visible) => {
        return visible ? (react_1.default.createElement(one_1.View, { className: classnames_1.default({
                [`${prefixCls}-image`]: true,
                [`${prefixCls}-active`]: active,
            }) })) : null;
    };
    const renderAvatar = (visible) => {
        return visible ? (react_1.default.createElement(one_1.View, { className: classnames_1.default({
                [`${prefixCls}-avatar`]: true,
                [`${prefixCls}-active`]: active,
            }) })) : null;
    };
    const renderTitle = (visible) => {
        return visible ? (react_1.default.createElement(one_1.View, { className: classnames_1.default({
                [`${prefixCls}-title`]: true,
                [`${prefixCls}-active`]: active,
            }), style: { backgroundColor: titleColor } })) : null;
    };
    const renderParagraph = () => {
        return rows.map((item, index) => (react_1.default.createElement(one_1.View, { key: item, className: classnames_1.default({
                [`${prefixCls}-row`]: true,
                [`${prefixCls}-active`]: active,
            }), style: {
                width: rowsWidth === null || rowsWidth === void 0 ? void 0 : rowsWidth[index],
            } })));
    };
    const renderSkeleton = () => {
        const skeleton = [...new Array(repetitions).keys()];
        return (react_1.default.createElement(react_1.default.Fragment, null, skeleton === null || skeleton === void 0 ? void 0 : skeleton.map((i, index) => (react_1.default.createElement(one_1.View, { key: i, className: `${prefixCls}-item`, style: { marginBottom: index !== skeleton.length - 1 ? space : 0 } }, customize ? (customize) : (react_1.default.createElement(react_1.default.Fragment, null,
            renderImage(image),
            renderAvatar(avatar),
            renderTitle(title),
            renderParagraph())))))));
    };
    if (fade) {
        return (react_1.default.createElement(one_1.View, { className: prefixCls }, !loadingEnd ? (react_1.default.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-placeholder`, {
                [`${prefixCls}-hidden`]: !loading,
            }), style: Object.assign({ backgroundColor }, style) }, renderSkeleton())) : (react_1.default.createElement(one_1.View, { className: classnames_1.default({
                [`${prefixCls}-container`]: true,
                [`${prefixCls}-container-active`]: renderStart,
            }) }, children))));
    }
    return (react_1.default.createElement(one_1.View, { className: prefixCls }, loading ? (react_1.default.createElement(one_1.View, { className: `${prefixCls}-placeholder`, style: Object.assign({ backgroundColor }, style) }, renderSkeleton())) : (react_1.default.createElement(one_1.View, { className: classnames_1.default({
            [`${prefixCls}-container`]: true,
            [`${prefixCls}-container-active`]: true,
        }) }, children))));
};
exports.default = Skeleton;
